import { Routes } from '@angular/router';
import { authGuard } from './guards/auth.guard';
import { adminGuard } from './guards/admin.guard';
import { deadlineConfigGuard } from './guards/deadline-config.guard';
import { permissionGuard } from './guards/permission.guard';
import { roleGuard } from './guards/role.guard';
import { unsavedChangesGuard } from './guards/unsaved-changes.guard';

/**
 * Nhom role cho menu Thong ke v2. Xem document/thong_ke_bao_cao_v2_DESIGN.md muc 8.2
 * (repo tndbackendapi) - phai khop voi antMatchers trong SecurityConfiguration.
 */
const ROLES_QUAN_LY = ['ROLE_ADMIN', 'ROLE_GIAM_DOC_NV'];
const ROLES_THAM_DINH = [...ROLES_QUAN_LY, 'ROLE_CHUYEN_VIEN_TD', 'ROLE_THAM_DINH_VIEN', 'ROLE_TDV_KY'];
// Nguoi phan cong xem trang Nang suat de can tai theo chi nhanh minh phu trach
const ROLES_NANG_SUAT = [...ROLES_THAM_DINH, 'ROLE_PHAN_CONG'];
const ROLES_KINH_DOANH = [...ROLES_QUAN_LY, 'ROLE_NVKD'];

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./pages/landing/landing.component').then(m => m.LandingComponent)
  },
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login.component').then(m => m.LoginComponent)
  },
  {
    path: 'register',
    loadComponent: () => import('./pages/register/register.component').then(m => m.RegisterComponent)
  },
  {
    path: 'forgot-password',
    loadComponent: () => import('./pages/forgot-password/forgot-password.component').then(m => m.ForgotPasswordComponent)
  },
  {
    path: 'new-password',
    loadComponent: () => import('./pages/new-password/new-password.component').then(m => m.NewPasswordComponent)
  },
  {
    path: 'chinh-sach-bao-mat-thong-tin',
    loadComponent: () => import('./pages/chinh-sach-bao-mat-thong-tin/chinh-sach-bao-mat-thong-tin.component').then(m => m.ChinhSachBaoMatThongTinComponent)
  },
  {
    path: 'change-password',
    loadComponent: () => import('./pages/change-password/change-password.component').then(m => m.ChangePasswordComponent),
    canActivate: [authGuard]
  },
  {
    path: 'tra-cuu-chung-thu',
    loadComponent: () => import('./pages/tra-cuu-chung-thu/tra-cuu-chung-thu.component').then(m => m.TraCuuChungThuComponent)
  },
  {
    path: 'tra-cuu-nhan-vien',
    loadComponent: () => import('./pages/tra-cuu-nhan-vien/tra-cuu-nhan-vien.component').then(m => m.TraCuuNhanVienComponent)
  },
  {
    path: 'tracking-request',
    loadComponent: () => import('./pages/tracking-request/tracking-request.component').then(m => m.TrackingRequestComponent)
  },
  {
    path: 'ho-so-phan-cong',
    loadComponent: () => import('./pages/ho-so-phan-cong/ho-so-phan-cong.component').then(m => m.HoSoPhanCongComponent),
    canActivate: [authGuard]
  },
  {
    path: 'ho-so-cua-toi',
    loadComponent: () => import('./pages/ho-so-cua-toi/ho-so-cua-toi.component').then(m => m.HoSoCuaToiComponent),
    canActivate: [authGuard]
  },
  {
    path: 'tai-lieu-in-an',
    loadComponent: () => import('./pages/tai-lieu-in-an/tai-lieu-in-an.component').then(m => m.TaiLieuInAnComponent),
    canActivate: [authGuard, roleGuard],
    data: { roles: ['ROLE_HANH_CHINH_IN_AN'] }
  },
  {
    // Xem/sửa bản PDF xem trước báo cáo/chứng thư ở tab riêng (tab Báo cáo → "Mở trong tab mới").
    // Không giới hạn role: mọi role xem được, BE kiểm tra quyền xem/ghi đè từng bản.
    path: 'xem-ban-pdf/:id',
    loadComponent: () => import('./pages/xem-ban-pdf/xem-ban-pdf.component').then(m => m.XemBanPdfComponent),
    canActivate: [authGuard]
  },
  {
    // Giu link cu: /dashboard -> /thong-ke/tong-quan
    path: 'dashboard',
    redirectTo: 'thong-ke/tong-quan',
    pathMatch: 'full'
  },
  {
    // Thong ke v2 - 4 lat cat quan tri.
    // Phan quyen o day chi de an UI; pham vi du lieu do backend accessWhere() quyet dinh.
    path: 'thong-ke',
    children: [
      {
        path: 'tong-quan',
        loadComponent: () => import('./pages/dashboard/dashboard.component').then(m => m.DashboardComponent),
        canActivate: [authGuard]
      },
      {
        path: 'nang-suat',
        loadComponent: () => import('./pages/thong-ke/nang-suat/nang-suat.component').then(m => m.NangSuatComponent),
        canActivate: [authGuard, roleGuard],
        // CVTD / KSV / TDV ky chi thay ho so minh phu trach; PHAN_CONG thay theo chi nhanh;
        // GIAM_DOC_NV thay tat ca van phong
        data: { roles: ROLES_NANG_SUAT }
      },
      {
        path: 'phan-loai-dia-ban',
        loadComponent: () => import('./pages/thong-ke/phan-loai-dia-ban/phan-loai-dia-ban.component')
          .then(m => m.PhanLoaiDiaBanComponent),
        canActivate: [authGuard, roleGuard],
        // NVKD chi thay ho so minh la CVKD; GIAM_DOC_NV thay tat ca van phong
        data: { roles: ROLES_KINH_DOANH }
      },
      {
        path: 'doi-tac',
        loadComponent: () => import('./pages/thong-ke/doi-tac/doi-tac.component')
          .then(m => m.DoiTacComponent),
        canActivate: [authGuard, roleGuard],
        // Doi soat doi tac: chi giam doc nghiep vu va admin
        data: { roles: ROLES_QUAN_LY }
      },
      {
        path: 'kho-du-lieu-gia',
        loadComponent: () => import('./pages/thong-ke/kho-du-lieu-gia/kho-du-lieu-gia.component')
          .then(m => m.KhoDuLieuGiaComponent),
        canActivate: [authGuard, roleGuard],
        data: { roles: ROLES_THAM_DINH }
      },
      { path: '', redirectTo: 'tong-quan', pathMatch: 'full' }
    ]
  },
  {
    path: 'list',
    loadComponent: () => import('./pages/list/list.component').then(m => m.ListComponent),
    canActivate: [authGuard]
  },
  {
    path: 'quantitative-apartment',
    loadComponent: () => import('./pages/quantitative-apartment/quantitative-apartment.component').then(m => m.QuantitativeApartmentComponent),
    canActivate: [authGuard]
  },
  {
    path: 'quantitative-different',
    loadComponent: () => import('./pages/quantitative-different/quantitative-different.component').then(m => m.QuantitativeDifferentComponent),
    canActivate: [authGuard]
  },
  {
    path: 'process-valuation',
    loadComponent: () => import('./pages/process-valuation/process-valuation.component').then(m => m.ProcessValuationComponent),
    canActivate: [authGuard]
  },
  {
    path: 'gui-yeu-cau-tham-dinh',
    loadComponent: () => import('./pages/gui-yeu-cau-tham-dinh/gui-yeu-cau-tham-dinh.component').then(m => m.GuiYeuCauThamDinhComponent)
  },
  {
    path: 'yeu-cau-tham-dinh',
    loadComponent: () => import('./pages/yeu-cau-tham-dinh/yeu-cau-tham-dinh.component').then(m => m.YeuCauThamDinhComponent),
    canActivate: [authGuard]
  },
  {
    path: 'yeu-cau-tham-dinh-gia',
    loadComponent: () => import('./pages/yeu-cau-tham-dinh-gia/yeu-cau-tham-dinh-gia.component').then(m => m.YeuCauThamDinhGiaComponent),
    canActivate: [authGuard]
  },
  {
    path: 'list-form-customer',
    loadComponent: () => import('./pages/list-form-customer/list-form-customer.component').then(m => m.ListFormCustomerComponent),
    canActivate: [authGuard]
  },
  {
    path: 'danh-sach-ho-so-nhap',
    loadComponent: () => import('./pages/danh-sach-ho-so-nhap/danh-sach-ho-so-nhap.component').then(m => m.DanhSachHoSoNhapComponent),
    canActivate: [authGuard]
  },
  {
    path: 'danh-sach-ho-so-tu-vang-lai',
    loadComponent: () => import('./pages/danh-sach-ho-so-tu-vang-lai/danh-sach-ho-so-tu-vang-lai.component').then(m => m.DanhSachHoSoTuVangLaiComponent),
    canActivate: [authGuard]
  },
  {
    path: 'quan-ly-thanh-toan',
    loadComponent: () => import('./pages/quan-ly-thanh-toan/quan-ly-thanh-toan.component').then(m => m.QuanLyThanhToanComponent),
    canActivate: [authGuard]
  },
  {
    path: 'quan-ly-thanh-toan/log-doi-soat',
    loadComponent: () => import('./pages/sepay-webhook-log/sepay-webhook-log.component').then(m => m.SepayWebhookLogComponent),
    canActivate: [authGuard]
  },
  {
    path: 'quan-ly-thanh-toan/:id',
    loadComponent: () => import('./pages/thanh-toan-chi-tiet/thanh-toan-chi-tiet.component').then(m => m.ThanhToanChiTietComponent),
    canActivate: [authGuard]
  },
  {
    path: 'quy-trinh-tham-dinh',
    loadComponent: () => import('./pages/quy-trinh-tham-dinh/quy-trinh-tham-dinh.component').then(m => m.QuyTrinhThamDinhComponent),
    canActivate: [authGuard],
    canDeactivate: [unsavedChangesGuard]
  },
  {
    path: 'danh-sach-user-tin-dung',
    loadComponent: () => import('./pages/danh-sach-user-tin-dung/danh-sach-user-tin-dung.component').then(m => m.DanhSachUserTinDungComponent),
    canActivate: [authGuard, permissionGuard],
    data: { permissions: ['tdnh:list_own'] }
  },
  {
    path: 'quan-ly-nvkd',
    loadComponent: () => import('./pages/quan-ly-nvkd/quan-ly-nvkd.component').then(m => m.QuanLyNvkdComponent),
    canActivate: [authGuard, permissionGuard],
    data: { permissions: ['tdnh:manage_scope'] }
  },
  {
    path: 'cong-no',
    loadComponent: () => import('./pages/cong-no/cong-no.component').then(m => m.CongNoComponent),
    canActivate: [authGuard]
  },
  {
    path: 'quan-ly-nguoi-dung',
    loadComponent: () => import('./pages/quan-ly-nguoi-dung/quan-ly-nguoi-dung.component').then(m => m.QuanLyNguoiDungComponent),
    canActivate: [authGuard, adminGuard]
  },
  {
    path: 'deadline-config',
    loadComponent: () => import('./pages/admin/deadline-config/deadline-config.component').then(m => m.DeadlineConfigComponent),
    canActivate: [authGuard, deadlineConfigGuard]
  },
  {
    path: 'appraisal-fee-config',
    loadComponent: () => import('./pages/admin/appraisal-fee-config/appraisal-fee-config.component').then(m => m.AppraisalFeeConfigComponent),
    canActivate: [authGuard, adminGuard]
  },
  {
    path: 'kpi-config',
    loadComponent: () => import('./pages/admin/kpi/kpi.component').then(m => m.KpiComponent),
    canActivate: [authGuard, roleGuard],
    // Phai khop antMatchers /api/v1/kpi/chinh-sach|nhan-su ben SecurityConfiguration
    data: { roles: ROLES_QUAN_LY }
  },
  {
    path: 'auto-assignment',
    loadComponent: () => import('./pages/auto-assignment/auto-assignment.component').then(m => m.AutoAssignmentComponent),
    canActivate: [authGuard, adminGuard]
  },
  {
    path: 'kho-gia',
    loadComponent: () => import('./pages/kho-gia/kho-gia-list.component').then(m => m.KhoGiaListComponent),
    canActivate: [authGuard]
  },
  {
    path: 'admin',
    loadComponent: () => import('./layouts/admin-layout/admin-layout.component').then(m => m.AdminLayoutComponent),
    canActivate: [authGuard, adminGuard],
    children: [
      {
        path: 'users',
        loadComponent: () => import('./pages/admin/users/users.component').then(m => m.UsersComponent)
      },
      {
        path: 'roles',
        loadComponent: () => import('./pages/admin/roles/roles.component').then(m => m.RolesComponent)
      },
      {
        path: 'roles/:roleId',
        loadComponent: () => import('./pages/admin/roles/role-detail/role-detail.component').then(m => m.RoleDetailComponent)
      },
      {
        path: 'permissions',
        loadComponent: () => import('./pages/admin/permissions/permissions.component').then(m => m.PermissionsComponent)
      },
      {
        path: 'permission-matrix',
        loadComponent: () => import('./pages/admin/permission-matrix/permission-matrix.component').then(m => m.PermissionMatrixComponent)
      },
      {
        path: 'organizations',
        loadComponent: () => import('./pages/admin/organizations/organizations.component').then(m => m.OrganizationsComponent)
      },
      {
        path: 'organizations/:idOrg',
        loadComponent: () => import('./pages/admin/organizations/organization-detail/organization-detail.component').then(m => m.OrganizationDetailComponent)
      },
      {
        path: 'organizations/:idOrg/:subOrgId',
        loadComponent: () => import('./pages/admin/organizations/sub-organization-detail/sub-organization-detail.component').then(m => m.SubOrganizationDetailComponent)
      },
      {
        path: '',
        redirectTo: 'users',
        pathMatch: 'full'
      }
    ]
  }
];

